import React from 'react';
import { QnAList } from 'customer';

export class QnA extends React.Component {
    render() {
        return (
            <div className="page-content-customer">
                <QnAList {...this.props} />
            </div>
        );
    }
}
